<mat-card>
  <mat-card-header>
    <mat-card-title>
      Organisations
    </mat-card-title>

    <mat-card-subtitle>
      <mat-form-field class="filter">
        <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
        <mat-hint>Comma seperate filter terms. (Eg. application, username)</mat-hint>
      </mat-form-field>
    </mat-card-subtitle>

    <button class="header-button" mat-raised-button color="accent" (click)="addOrganisation()">Add</button>
    <button class="header-button" mat-stroked-button color="warn" (click)="removeSelectedRows()"
      [disabled]="selection.selected.length==0">Delete</button>
  </mat-card-header>

  <mat-card-content>

    <table mat-table [dataSource]="dataSource" matSort>

      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
        <mat-cell class="org-name-cell" *matCellDef="let organisation">
          <span class="mobile-label">Name:</span>
          <div class="org-name">{{organisation.name}}</div>
          <div class="row-actions"><button (click)="onEditClick(organisation)">Edit</button> | <button
              (click)="onDetailsClick(organisation)">View Details</button></div>
        </mat-cell>
      </ng-container>

      <!-- Industry Column -->
      <ng-container matColumnDef="industries">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Industry </mat-header-cell>
        <mat-cell *matCellDef="let organisation">
          <span class="mobile-label">Industry:</span>
          <mat-chip-listbox *ngIf="organisation.industries" aria-label="Industries">
            <mat-chip-option *ngFor="let industry of organisation.industries">
              {{industry.name}}
            </mat-chip-option>
          </mat-chip-listbox>
        </mat-cell>
      </ng-container>

      <!-- Comments Column -->
      <ng-container matColumnDef="comments">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Comments </mat-header-cell>
        <mat-cell *matCellDef="let organisation">
          <span class="mobile-label">Comments:</span>
          {{organisation.comments}}
        </mat-cell>
      </ng-container>

      <!-- CRM Link Column -->
      <ng-container matColumnDef="crmLink">
        <mat-header-cell *matHeaderCellDef mat-sort-header> CRM Link </mat-header-cell>
        <mat-cell *matCellDef="let organisation" (click)="$event.stopPropagation()">
          <span class="mobile-label">CRM Link:</span>
          <a *ngIf="organisation.crmLink" [href]="organisation.crmLink" target="_blank">CRM</a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row class="user-row" *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </table>

    <mat-spinner *ngIf="isLoading"></mat-spinner>

  </mat-card-content>

  <mat-card-actions align="end">
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
  </mat-card-actions>

</mat-card>